import type { FieldState, FieldTree } from '@angular/forms/signals';

/**
 * Resolves a top-level field on a signal-form root (e.g. `email` on `FieldTree<{ email: string }>`).
 */
export function getFieldStateForKey(
  root: FieldTree<unknown>,
  key: string,
): FieldState<unknown> | null {
  const branch = (root as unknown as Record<string, unknown>)[key];
  if (typeof branch !== 'function') {
    return null;
  }
  return (branch as () => FieldState<unknown>)();
}

export function fieldHasVisibleErrors(
  root: FieldTree<unknown>,
  key: string,
): boolean {
  const state = getFieldStateForKey(root, key);
  if (!state) return false;
  return state.invalid() && (state.dirty() || state.touched());
}
